export const environment = {
  production: true,
  API_BASE_PATH: 'https://api.oak-events.com/api',
  ALLOWED_DOMAINS: ['api.oak-events.com'],
  splashPageTitle: 'OAK Watermark',
  splashPageRouterLink: ['/', 'auth', 'login'],
  loginPageRouterLink: ['/', 'main', 'companies'],
  companyListRouterLink: ['/', 'main', 'watermark'],
  SENTRY_DSN: 'https://dc11347f12148f9af5654641d74e76a7@o4503958405709824.ingest.us.sentry.io/4509497494470656',
};
